import * as React from 'react'
import { createContext } from 'use-context-selector'
import { useAppContextState } from 'app/@hooks'
import { PACKAGES_TABS } from 'app/@common/constants'


const Context = createContext({})


export function PackagesSelectedTabProvider({children}) {

    const { state, updateState } = useAppContextState({ selectedTab: PACKAGES_TABS.MIN_PRICE  })

    return <Context.Provider value={{state, updateState}}>
        {children}
    </Context.Provider>
}

export default Context